import React, { Component } from 'react';
import * as d3 from "d3";

import StringUtils from '../../services/StringUtils.js';

import '../../../css/UserCharts.css';

class BarChart extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      data: props.data,
      type: props.type,
      label: props.label,
      clickCb: props.clickCb
    }

  }

  componentWillReceiveProps(newProps) {
    
    this.setState({
      data: newProps.data,
      type: newProps.type,
      label: newProps.label,
      clickCb: newProps.clickCb
    });

    let data = newProps.data;
    let type = newProps.type;
    let label = newProps.label;
    let clickCb = newProps.clickCb;
    this.renderBarChart(data, label, type, clickCb);

  }

  componentDidMount() {
    this.renderBarChart();
    this.eventHandler = this.updateDimensions.bind(this);
    window.addEventListener("resize", this.eventHandler);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.eventHandler);
  }

  updateDimensions() {
    let data = this.state.data;
    if (!data || (this.lastWidth && this.lastWidth === this.getWidth()))
      return;
    this.renderBarChart();
  }

  getWidth() {
    let width = document.getElementById('container').offsetWidth*0.96;
    return width;
  }

  renderBarChart() {

    let data = this.state.data;
    let yLabel = this.state.label;
    let type = this.state.type;
    let onClickCb = this.state.clickCb;

    if (!data)
      return;

    if (this.refs.barChart)
      d3.select(this.refs.barChart).html('');

    let margin = {top: 20, right: 0, bottom: 30, left: 70};

    let width =  Math.max(this.getWidth(), 700);
    this.lastWidth = width;

    let height = 450;

    let x = d3.scale.ordinal()
    .rangeRoundBands([25, width - margin.left - margin.right], .1);

    let y = d3.scale.linear()
    .range([height, 0]);

    let xAxis = d3.svg.axis()
    .scale(x)
    .orient("bottom");

    let yAxis = d3.svg.axis()
    .scale(y)
    .orient("left");

    let svg = d3.select(this.refs.barChart)
    .attr("width", width)
    .attr("height", height + margin.top + margin.bottom)
    .append("g")
    .attr("transform", `translate(${margin.left},${margin.top})`);
    
    // format the data
    data.forEach(function(d) {
      d.count = +d.count;
      d.date = StringUtils.convertMonthString(d.year+'/'+d.month);
    });

    // Scale the range of the data in the domains
    x.domain(data.map(function(d) { return d.date; }));
    y.domain([0, d3.max(data, function(d) { return d.count; })]);

    // append the rectangles for the bar chart
    svg.selectAll(".bar")
    .data(data)
    .enter().append("rect")
    .attr("class", "bar clickable")
    .attr("x", function(d) { return x(d.date); })
    .attr("width", x.rangeBand())
    .attr("y", function(d) { return y(d.count); })
    .attr("height", function(d) { return height - y(d.count); })
    .on("click", (d) => {
      onClickCb(d, type)
    })
    .append('title')                                               
    .text(function(d){
      //return `${d.date}: ${d.count}`
      return d.count;
    });

    // add the x Axis
    svg.append("g")
    .attr("class", "x axis")
    .attr("transform", `translate(0,${height})`)
    .call(xAxis);

    // add the y Axis
    svg.append("g")
    .attr("class", "y axis")
    .call(yAxis)
    .append("text")
    .attr("transform", "rotate(-90)")
    .attr("y", 6)
    .attr("x",5)
    .attr("dy", ".71em")
    .style("text-anchor", "end")
    .text(yLabel);
   
  }

  render() {

    return (
      <div className="selector">
        <svg ref="barChart" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision">
        </svg>
      </div>
    );
  }

}

export default BarChart;



// WEBPACK FOOTER //
// ./src/js/components/charts/BarChart.jsx